"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Arrow = _interopRequireDefault(require("./Arrow.js"));
var _round2 = _interopRequireDefault(require("lodash/round"));
var _min2 = _interopRequireDefault(require("lodash/min"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _default, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      placeholderPosition: -1 // in percents
    });
    _defineProperty(_assertThisInitialized(_this), "_getStyle", function () {
      return _this.props.style || _style["default"];
    });
    _defineProperty(_assertThisInitialized(_this), "_getPositionClass", function (position) {
      var style = _this._getStyle();
      if (position === 'right') {
        return style.rightPosition;
      }
      if (position === 'center') {
        return style.centerPosition;
      }
      return style.leftPosition;
    });
    _defineProperty(_assertThisInitialized(_this), "_movePlaceholderToPosition", function (position) {
      return new Promise(function (resolve, reserve) {
        _this.setState({
          placeholderPosition: position
        }, function () {
          return resolve();
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleMouseX", function (x) {
      var _this$refs$bar$getBou = _this.refs.bar.getBoundingClientRect(),
        left = _this$refs$bar$getBou.left,
        right = _this$refs$bar$getBou.right;

      // Determine mouse position
      var mousePosition = Math.min(Math.max(x, left), right);
      var placeholderPercent = (mousePosition - left) / (right - left) * 100;
      if (_this.props.settings.snapToLabels) {
        placeholderPercent = _this._snapPositionToLabels(placeholderPercent);
      }
      return _this._movePlaceholderToPosition(placeholderPercent);
    });
    _defineProperty(_assertThisInitialized(_this), "_snapPositionToLabels", function (position) {
      var min = +_this.props.settings.min;
      var max = +_this.props.settings.max;
      var labels = _this.props.settings.labels;
      var value = +min + (max - min) / 100 * position;
      var result;
      var div = 99999;
      (0, _forEach2["default"])(labels, function (label) {
        if (Math.abs(value - label.value) < div) {
          div = Math.abs(value - label.value);
          result = +label.value;
        }
      });
      return _this._convertValueToPercent(result);
    });
    _defineProperty(_assertThisInitialized(_this), "_changeValue", function () {
      var value = _this._convertPercentToValue(_this.state.placeholderPosition);
      _this.props.field.onChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "_convertValueToPercent", function (value) {
      var min = +_this.props.settings.min;
      var max = +_this.props.settings.max;
      var percent = (value - min) / (max - min) * 100;
      return +(0, _min2["default"])([100, (0, _max2["default"])([0, percent])]);
    });
    _defineProperty(_assertThisInitialized(_this), "_convertPercentToValue", function (percent) {
      var min = +_this.props.settings.min;
      var max = +_this.props.settings.max;
      var value = (0, _round2["default"])(min + (max - min) / 100 * percent);
      return +(0, _min2["default"])([max, (0, _max2["default"])([min, value])]);
    });
    _defineProperty(_assertThisInitialized(_this), "_barClicked", function (event) {
      var x = event.clientX;
      _this._handleMouseX(x).then(_this._changeValue);
    });
    _defineProperty(_assertThisInitialized(_this), "_hasValue", function () {
      var field = _this.props.field;
      return field.value !== undefined && field.value !== '';
    });
    return _this;
  }
  _createClass(_default, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        field = _this$props.field,
        settings = _this$props.settings;
      var style = this._getStyle();
      var showArrow = this.state.placeholderPosition !== -1 || this._hasValue();
      var leftPosition = this.state.placeholderPosition !== -1 ? this.state.placeholderPosition : this._convertValueToPercent(field.value);
      var topLabels = (0, _filter2["default"])(settings.labels, {
        verticalPosition: 'top'
      });
      var bottomLabels = (0, _filter2["default"])(settings.labels, {
        verticalPosition: 'bottom'
      });
      var labelRender = function labelRender(label, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: label.id,
          className: style.labelWrapper,
          style: {
            marginLeft: _this2._convertValueToPercent(label.value) + '%',
            marginRight: '-' + _this2._convertValueToPercent(label.value) + '%'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: style.label + ' ' + _this2._getPositionClass(label.position)
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          registerAction: _this2.props.registerAction.bind(null, index + 2),
          setParameters: _this2.props.setParameters,
          content: label.name,
          accommodations: _this2.props.accommodations,
          allowMasking: true
        })));
      };
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: field,
        showErrorsImmediately: false
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'clearfix ' + style.wrapper,
        onClick: this._barClicked,
        style: {
          maxWidth: settings.maxWidth
        }
      }, topLabels.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: 'clearfix ' + style.topLabels
      }, topLabels.map(labelRender)), /*#__PURE__*/_react["default"].createElement("div", {
        className: style.barWrapper
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: style.bar,
        ref: "bar"
      }), showArrow && /*#__PURE__*/_react["default"].createElement(_Arrow["default"], {
        leftPosition: leftPosition,
        handleMouseX: this._handleMouseX,
        onDrop: this._changeValue,
        currentValue: this._convertPercentToValue(this.state.placeholderPosition),
        settings: settings,
        style: style
      }), settings.labels && settings.labels.map(function (label) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: label.id,
          style: {
            position: 'absolute',
            left: _this2._convertValueToPercent(label.value) + '%'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: style.stick
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: style.stickInside
        }));
      })), bottomLabels.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: 'clearfix ' + style.bottomLabels
      }, bottomLabels.map(labelRender))));
    }
  }]);
  return _default;
}(_react["default"].Component);
_defineProperty(_default, "propTypes", {
  settings: _propTypes["default"].object.isRequired,
  field: _propTypes["default"].object.isRequired,
  style: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  accommodations: _propTypes["default"].object
});